import { EXPORT_STATUS_HEIGHT } from 'helpers/globals'

const iconContainer = {
  display: 'flex',
  height: '100%',
  width: '100%',
  fontSize: '1.3rem',
  position: 'absolute',
  left: 0,
  top: 0,
  '& svg': {
    margin: 'auto'
  }
}

export default {
  container: {
    height: ({ exporting }) => exporting ? EXPORT_STATUS_HEIGHT : 0,
    maxHeight: EXPORT_STATUS_HEIGHT,
    position: 'absolute',
    bottom: 0,
    left: 0,
    background: 'white',
    fontSize: '1.5rem',
    zIndex: 1,
    width: '100vw',
    overflow: 'hidden'
  },
  progressContainer: {
    display: 'inline-block',
    maxHeight: EXPORT_STATUS_HEIGHT
  },
  progressText: {
    fontWeight: 'bold',
    display: 'inline-block',
    height: EXPORT_STATUS_HEIGHT,
    verticalAlign: 'top',
    lineHeight: `${EXPORT_STATUS_HEIGHT}px`
  },
  iconProcessing: iconContainer,
  iconDanger: {
    ...iconContainer,
    fontSize: '2rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/ExportStatus/style.js